import React, { createContext, useContext, useState } from 'react';

const translations = {
  en: {
    // Navbar
    nav_glass: 'Screen Glass', nav_speakers: 'Speakers',
    nav_playstation: 'PlayStation', nav_about: 'About', nav_contact: 'Contact',
    nav_home: 'Home', nav_search_placeholder: 'Search for a product...',
    nav_earphones: 'Earphones', nav_phone_cases: 'Phone Cases',
    nav_chargers: 'Chargers', nav_smartwatches: 'Smart Watches',
    nav_powerbanks: 'Power Banks', nav_gaming_accessories: 'Gaming Accessories',
    nav_accessories: 'Accessories',

    // Hero
    hero_top_banner: '⚡ EXPRESS 24H DELIVERY — ALL OVER TUNISIA',
    hero_badge: '🔴 New Collection 2026', hero_title_1: 'The reference for',
    hero_title_2: 'tech accessories', hero_title_3: 'in Tunisia',
    hero_subtitle: 'High-performance audio, gaming & accessories. Tested, in stock, delivered in 24h all over Tunisia.',
    hero_by: 'By Maher — quality guaranteed.',
    hero_cta_buy: 'Shop Now', hero_cta_view: 'See All Products',
    hero_stat_products: 'Products', hero_stat_clients: 'Customers', hero_stat_rating: 'Rating',
    hero_shipping_label: 'Free Shipping', hero_shipping_sub: 'From 150 TND',
    hero_flash_label: 'Flash Deal', hero_flash_sub: 'Up to -40%',
    top_sales_title: 'Top Sales', top_sales_see_all: 'See all',

    // Categories
    cat_all: 'All', cat_glass: 'Screen Glass',
    cat_speakers: 'Speakers', cat_playstation: 'PlayStation',
    cat_earphones: 'Earphones', cat_phone_cases: 'Phone Cases',
    cat_chargers: 'Chargers', cat_smartwatches: 'Smart Watches',
    cat_powerbanks: 'Power Banks', cat_gaming_accessories: 'Gaming Accessories',
    cat_accessories: 'Accessories',

    // Sections
    section_glass: 'Screen Protection',
    section_speakers: 'Premium Speakers', section_playstation: 'PlayStation',
    section_earphones: 'Earphones', section_phone_cases: 'Phone Cases',
    section_chargers: 'Chargers', section_smartwatches: 'Smart Watches',
    section_powerbanks: 'Power Banks', section_gaming_accessories: 'Gaming Accessories',
    section_accessories: 'Accessories',

    // Product card
    quick_view: 'Quick View', add_to_cart: 'Add to Cart',
    added: '✓ Added!', in_cart: 'In Cart', add_more: 'Add more',
    choose_model: 'Choose a Model', select_model: 'Select your model',
    select_model_placeholder: 'Search a model...', models_available: 'models available',

    // Search
    results_found: 'result(s) found', clear_filters: 'Clear filters',
    no_results: 'No products found. Try a different search.',

    // Cart
    cart_title: 'My Cart', cart_empty: 'Your cart is empty',
    cart_start: 'Start Shopping', cart_subtotal: 'Subtotal',
    cart_shipping: 'Shipping', cart_shipping_free: 'FREE',
    cart_total: 'Total', cart_free_hint: 'more for free shipping!',
    cart_checkout: 'Checkout', cart_clear: 'Clear Cart', cart_unit: 'unit',

    // Product detail
    reviews: 'reviews', you_save: 'You save',
    in_stock: 'In Stock', low_stock: 'Low Stock', out_of_stock: 'Out of Stock',
    free_delivery: 'Free Delivery', free_delivery_sub: 'On orders over 150 TND',
    easy_return: 'Easy Returns', easy_return_sub: '30-day return policy',
    warranty: '1 Year Warranty', warranty_sub: 'Manufacturer warranty',
    related_products: 'You might also like',
    not_found: 'Product not found', back_home: 'Back to Home',

    // Category page
    browse: 'Browse', products_available: 'products available',
    sort_default: 'Default', sort_price_asc: 'Price: Low to High',
    sort_price_desc: 'Price: High to Low', sort_rating: 'Top Rated',

    // Checkout
    checkout_title: 'Checkout', delivery_info: 'Delivery Information',
    first_name: 'First Name', last_name: 'Last Name',
    email: 'Email', phone: 'Phone', address: 'Address',
    city: 'City', governorate: 'Governorate', select_governorate: 'Select governorate',
    payment_method: 'Payment Method', pay_cash: 'Cash on Delivery',
    pay_transfer: 'Bank Transfer', place_order: 'Place Order',
    order_summary: 'Order Summary',
    order_success_title: 'Order Confirmed! 🎉',
    order_success_sub: 'Thank you! We will contact you shortly to confirm your order.',
    order_total: 'Order total', continue_shopping: 'Continue Shopping',
    required: 'This field is required', invalid_email: 'Invalid email address',
    invalid_phone: 'Invalid phone number',
    checkout_stock_error: 'Some items in your cart are no longer available in the requested quantity. Please adjust your cart and try again.',
    checkout_generic_error: 'Something went wrong while placing your order. Please try again.',
    checkout_network_error: 'Unable to reach the server. Check your connection and try again — your order was not placed.',

    // About
    about_title: 'About Matrix Electronic',
    about_subtitle: 'Tunisia\'s trusted destination for tech accessories — by Maher.',
    our_story: 'Our Story', our_story_p1: 'Matrix Electronic was founded with a simple mission: to bring quality tech accessories to every Tunisian at fair prices. What started as a small passion project by Maher has grown into one of Tunisia\'s most trusted accessory stores.',
    our_story_p2: 'We carefully curate every product we sell — from earphones and speakers to phone cases, gaming accessories, chargers, and smart watches. Our team tests every item to ensure it meets our quality standards.',
    contact_us_btn: 'Contact Us', our_values: 'Our Values',
    val_quality: 'Quality First', val_quality_desc: 'Every product is tested and verified before listing.',
    val_innovation: 'Always Latest', val_innovation_desc: 'We track global launches and bring them to Tunisia fast.',
    val_trust: 'Trusted by Thousands', val_trust_desc: 'Over 50,000 customers have chosen Matrix.',
    val_service: 'After-Sale Service', val_service_desc: 'We\'re here for you after your purchase too.',
    about_stat_products: 'Products', about_stat_customers: 'Happy Customers',
    about_stat_years: 'Years in Business', about_stat_rating: 'Average Rating',
    about_cta_title: 'Ready to upgrade your tech?',
    about_cta_sub: 'Browse our full catalog and find your next device.',
    shop_now_btn: 'Shop Now',

    // Contact
    contact_title: 'Contact Us', contact_subtitle: 'We\'re here to help. Reach out anytime.',
    get_in_touch: 'Get in Touch',
    contact_info_desc: 'Have a question about a product or your order? Our team is ready to assist you.',
    contact_address_label: 'Address', contact_phone_label: 'Phone',
    contact_email_label: 'Email', contact_hours_label: 'Hours',
    contact_hours_value: 'Mon–Sat 9:00 AM – 7:00 PM',
    send_message: 'Send a Message',
    your_name: 'Your Name', your_email: 'Your Email',
    your_subject: 'Subject', your_message: 'Message',
    send_message_btn: 'Send Message →',
    message_sent_title: 'Message Sent!',
    message_sent_sub: 'We\'ll get back to you within 24 hours.',
    send_another: 'Send another message',

    // Footer
    footer_desc: 'Your premium destination for tech accessories. Quality guaranteed.',
    footer_products: 'Products', footer_glass: 'Screen Protectors',
    footer_speakers: 'Speakers', footer_ps: 'PlayStation', footer_service: 'Service',
    footer_track: 'Track Order', footer_returns: 'Returns', footer_warranty: 'Warranty',
    footer_contact: 'Contact Us', footer_company: 'Matrix', footer_about: 'About Us',
    footer_careers: 'Careers', footer_blog: 'Blog', footer_privacy: 'Privacy Policy',
    footer_copy: '© 2024 Matrix Electronic Devices by Maher — All rights reserved.',
  },

  fr: {
    // Navbar
    nav_glass: 'Protection Écran', nav_speakers: 'Enceintes',
    nav_playstation: 'PlayStation', nav_about: 'À Propos', nav_contact: 'Contact',
    nav_home: 'Accueil', nav_search_placeholder: 'Rechercher un produit...',
    nav_earphones: 'Écouteurs', nav_phone_cases: 'Coques',
    nav_chargers: 'Chargeurs', nav_smartwatches: 'Montres Connectées',
    nav_powerbanks: 'Batteries Externes', nav_gaming_accessories: 'Accessoires Gaming',
    nav_accessories: 'Accessoires',

    // Hero
    hero_top_banner: '⚡ LIVRAISON EXPRESS 24H — TOUTE LA TUNISIE',
    hero_badge: '🔴 Nouvelle Collection 2026', hero_title_1: 'La référence en',
    hero_title_2: 'accessoires tech', hero_title_3: 'en Tunisie',
    hero_subtitle: 'Audio, gaming et accessoires haute performance. Testé, stocké, livré en 24h partout en Tunisie.',
    hero_by: 'By Maher — qualité garantie.',
    hero_cta_buy: 'Acheter Maintenant', hero_cta_view: 'Voir les Produits',
    hero_stat_products: 'Produits', hero_stat_clients: 'Clients', hero_stat_rating: 'Note',
    hero_shipping_label: 'Livraison Gratuite', hero_shipping_sub: 'Dès 150 TND',
    hero_flash_label: 'Offre Flash', hero_flash_sub: 'Jusqu\'à -40%',
    top_sales_title: 'Top Ventes', top_sales_see_all: 'Tout voir',

    // Categories
    cat_all: 'Tout', cat_glass: 'Protection Écran',
    cat_speakers: 'Enceintes', cat_playstation: 'PlayStation',
    cat_earphones: 'Écouteurs', cat_phone_cases: 'Coques',
    cat_chargers: 'Chargeurs', cat_smartwatches: 'Montres Connectées',
    cat_powerbanks: 'Batteries Externes', cat_gaming_accessories: 'Accessoires Gaming',
    cat_accessories: 'Accessoires',

    // Sections
    section_glass: 'Protection Écran',
    section_speakers: 'Enceintes Premium', section_playstation: 'PlayStation',
    section_earphones: 'Écouteurs', section_phone_cases: 'Coques de Téléphone',
    section_chargers: 'Chargeurs', section_smartwatches: 'Montres Connectées',
    section_powerbanks: 'Batteries Externes', section_gaming_accessories: 'Accessoires Gaming',
    section_accessories: 'Accessoires',

    // Product card
    quick_view: 'Aperçu rapide', add_to_cart: 'Ajouter',
    added: '✓ Ajouté !', in_cart: 'Panier', add_more: 'Ajouter encore',
    choose_model: 'Choisir un modèle', select_model: 'Sélectionnez votre modèle',
    select_model_placeholder: 'Rechercher un modèle...', models_available: 'modèles disponibles',

    // Search
    results_found: 'résultat(s) trouvé(s)', clear_filters: 'Effacer les filtres',
    no_results: 'Aucun produit trouvé. Essayez une autre recherche.',

    // Cart
    cart_title: 'Mon Panier', cart_empty: 'Votre panier est vide',
    cart_start: 'Commencer mes achats', cart_subtotal: 'Sous-total',
    cart_shipping: 'Livraison', cart_shipping_free: 'GRATUITE',
    cart_total: 'Total', cart_free_hint: 'de plus pour la livraison gratuite !',
    cart_checkout: 'Commander', cart_clear: 'Vider le panier', cart_unit: 'unité',

    // Product detail
    reviews: 'avis', you_save: 'Vous économisez',
    in_stock: 'En Stock', low_stock: 'Stock Faible', out_of_stock: 'Rupture de Stock',
    free_delivery: 'Livraison Gratuite', free_delivery_sub: 'Dès 150 TND d\'achat',
    easy_return: 'Retour Facile', easy_return_sub: 'Politique de retour 30 jours',
    warranty: 'Garantie 1 An', warranty_sub: 'Garantie fabricant',
    related_products: 'Vous aimerez aussi',
    not_found: 'Produit introuvable', back_home: 'Retour à l\'accueil',

    // Category page
    browse: 'Parcourir', products_available: 'produits disponibles',
    sort_default: 'Par défaut', sort_price_asc: 'Prix croissant',
    sort_price_desc: 'Prix décroissant', sort_rating: 'Mieux notés',

    // Checkout
    checkout_title: 'Commande', delivery_info: 'Informations de livraison',
    first_name: 'Prénom', last_name: 'Nom',
    email: 'Email', phone: 'Téléphone', address: 'Adresse',
    city: 'Ville', governorate: 'Gouvernorat', select_governorate: 'Choisir un gouvernorat',
    payment_method: 'Mode de paiement', pay_cash: 'Paiement à la livraison',
    pay_transfer: 'Virement bancaire', place_order: 'Passer la commande',
    order_summary: 'Récapitulatif',
    order_success_title: 'Commande confirmée ! 🎉',
    order_success_sub: 'Merci ! Nous vous contacterons rapidement pour confirmer votre commande.',
    order_total: 'Total commande', continue_shopping: 'Continuer mes achats',
    required: 'Ce champ est obligatoire', invalid_email: 'Adresse email invalide',
    invalid_phone: 'Numéro de téléphone invalide',
    checkout_stock_error: 'Certains articles de votre panier ne sont plus disponibles dans la quantité demandée. Ajustez votre panier et réessayez.',
    checkout_generic_error: "Une erreur s'est produite lors de la commande. Merci de réessayer.",
    checkout_network_error: "Impossible de contacter le serveur. Vérifiez votre connexion et réessayez — votre commande n'a pas été enregistrée.",

    // About
    about_title: 'À Propos de Matrix Electronic',
    about_subtitle: 'La référence tunisienne en accessoires tech — by Maher.',
    our_story: 'Notre Histoire', our_story_p1: 'Matrix Electronic a été fondée avec une mission simple : apporter des accessoires tech de qualité à chaque Tunisien à des prix justes. Ce qui a commencé comme un projet passion de Maher est devenu l\'une des boutiques les plus fiables de Tunisie.',
    our_story_p2: 'Nous sélectionnons soigneusement chaque produit que nous vendons — des écouteurs et enceintes aux coques, accessoires gaming, chargeurs et montres connectées. Notre équipe teste chaque article pour garantir nos standards de qualité.',
    contact_us_btn: 'Contactez-nous', our_values: 'Nos Valeurs',
    val_quality: 'Qualité Avant Tout', val_quality_desc: 'Chaque produit est testé et vérifié avant mise en ligne.',
    val_innovation: 'Toujours à la Pointe', val_innovation_desc: 'Nous suivons les sorties mondiales et les apportons rapidement en Tunisie.',
    val_trust: 'Confiance de Milliers', val_trust_desc: 'Plus de 50 000 clients ont choisi Matrix.',
    val_service: 'Service Après-Vente', val_service_desc: 'Nous sommes là pour vous même après votre achat.',
    about_stat_products: 'Produits', about_stat_customers: 'Clients Satisfaits',
    about_stat_years: 'Ans d\'expérience', about_stat_rating: 'Note Moyenne',
    about_cta_title: 'Prêt à upgrader votre tech ?',
    about_cta_sub: 'Parcourez notre catalogue complet et trouvez votre prochain appareil.',
    shop_now_btn: 'Acheter Maintenant',

    // Contact
    contact_title: 'Contactez-nous', contact_subtitle: 'Nous sommes là pour vous aider. Écrivez-nous.',
    get_in_touch: 'Nous Contacter',
    contact_info_desc: 'Une question sur un produit ou une commande ? Notre équipe est prête à vous aider.',
    contact_address_label: 'Adresse', contact_phone_label: 'Téléphone',
    contact_email_label: 'Email', contact_hours_label: 'Horaires',
    contact_hours_value: 'Lun–Sam 9h00 – 19h00',
    send_message: 'Envoyer un message',
    your_name: 'Votre Nom', your_email: 'Votre Email',
    your_subject: 'Sujet', your_message: 'Message',
    send_message_btn: 'Envoyer →',
    message_sent_title: 'Message Envoyé !',
    message_sent_sub: 'Nous vous répondrons dans les 24 heures.',
    send_another: 'Envoyer un autre message',

    // Footer
    footer_desc: 'Votre destination premium pour les accessoires tech. Qualité garantie.',
    footer_products: 'Produits', footer_glass: 'Protections Écran',
    footer_speakers: 'Enceintes', footer_ps: 'PlayStation', footer_service: 'Service',
    footer_track: 'Suivi Commande', footer_returns: 'Retours', footer_warranty: 'Garantie',
    footer_contact: 'Contactez-nous', footer_company: 'Matrix', footer_about: 'À Propos',
    footer_careers: 'Carrières', footer_blog: 'Blog', footer_privacy: 'Politique de confidentialité',
    footer_copy: '© 2024 Matrix Electronic Devices by Maher — Tous droits réservés.',
  }
};

const LangContext = createContext();

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState('en');
  const t = (key) => translations[lang][key] || key;
  const toggle = () => setLang(l => l === 'en' ? 'fr' : 'en');
  return (
    <LangContext.Provider value={{ lang, t, toggle }}>
      {children}
    </LangContext.Provider>
  );
};

export const useLang = () => useContext(LangContext);
